export interface ErrorReporter {
  captureException: (error: unknown, context?: Record<string, unknown>) => void
}

let reporter: ErrorReporter = {
  captureException: (error) => {
    console.error(error)
  },
}

export function setErrorReporter(customReporter: ErrorReporter): void {
  reporter = customReporter
}

export function reportError(error: unknown, context?: Record<string, unknown>): void {
  reporter.captureException(error, context)
}

export function installGlobalErrorHandlers(): void {
  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason, { source: 'unhandledrejection' })
  })

  window.addEventListener('error', (event) => {
    reportError(event.error ?? event.message, { source: 'window.onerror' })
  })
}
